// extracted by mini-css-extract-plugin
export default {"heading":"MealTitle_heading__q-rJV"};